<template>
  <div class="subview message">
    <div class="message-wrapper">
      <!-- Error || Canceled -->
      <template v-if="!loading && (status === 'error' || status === 'canceled')">
        <sprite
          :width="111"
          :height="111"
          :type="'message-error'"
        />
        <h1 class="message-title">Ooops</h1>
        <p class="message-text">Paiement refusé, veuillez réessayer ou prendre contact avec le Théâtre de Liège.</p>

        <btn @click="onUpdate" >
          Veuillez essayer de nouveau
        </btn>
      </template>

      <!-- Success -->
      <template v-if="!loading && status === 'success'">
        <sprite
          :width="111"
          :height="111"
          :type="'message-success'"
        />
        <template v-if="message && message === 'paid'">
          <h1 class="message-title">Merci pour votre réservation</h1>
          <p
            v-if="isStream"
            class="message-text"
          >
            Retrouvez vos codes d’accès dans la section "Mes&nbsp;billets".<br><br> À bientôt.
          </p>
          <p v-else class="message-text">Retrouvez vos billets dans la section "Mes&nbsp;billets".<br><br> À bientôt.</p>
        </template>
        <template v-else>
          <template>
            <h1 class="message-title">Merci pour votre achat</h1>
            <p class="message-text">Paiement effectué avec succès&nbsp;!</p>
          </template>
        </template>
        <!-- <btn @click="onBackToHome">
          Retourner à l'accueil
        </btn> -->
        <btn @click="onOrders">
          Afficher mes billets
        </btn>
      </template>

      <!-- Waiting -->
      <template v-if="!loading && status === 'waiting'">
        <sprite
          :width="111"
          :height="111"
          :type="'message-loading'"
        />
        <h1 class="message-title">Le paiement est en cours</h1>
        <p class="message-text">Vous recevrez une confirmation par email.</p>
        <btn @click="onUpdate">
          Veuillez essayer de nouveau
        </btn>
      </template>
    </div>
  </div>
</template>

<script>
import Btn from '@/components/components/Btn.vue';
import Sprite from '@/components/components/Sprite.vue';

export default {
  components: {
    Btn,
    Sprite
  },
  beforeMount() {
    this.checkStatus();
  },
  computed: {
    message() {
      return this.$store.state.basket.message;
    },
    status() {
      return this.$store.state.basket.status;
    },
    isStream() {
      // console.log(this.$route.query);
      return this.$route.query.stream;
    },
    loading() {
      return this.$store.state.basket.requests !== 0;
    }
  },
  methods: {
    onTryAgain() {
      this.$store.dispatch('basket/pay', 'success');
    },
    onTickets() {
      this.$router.push({ name: 'Tickets' });
    },
    onBackToHome() {
      this.$router.push({ name: 'Home' });
    },
    onOrders() {
      this.$store.dispatch('profile/getOrders');
      this.$router.push({ name: 'Orders' });
    },
    onUpdate() {
      this.checkStatus();
    },
    checkStatus() {
      const orderStatus = localStorage.getItem('orderStatus');
      const checkoutID = localStorage.getItem('mollie_checkout_id');

      if (checkoutID) {
        this.$store.dispatch('basket/getStatus', {
          mollieID: checkoutID,
          orderID: orderStatus
        });
      }
    },
  }
};
</script>

<style lang="scss" scoped>
.message {
  @include padding(null 10px);
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: calc(100vh - 176px);

  &-wrapper {
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  &-title {
    @include margin(32px null null);
    @include font('primary', 'bold');
    font-size: rem(24px);
    line-height: (27 / 24);
    text-align: center;
  }

  &-text {
    @include margin(26px null null);
    text-align: center;
  }

  .btn {
    @include margin(38px null null);
    @include padding(15px null);
    min-width: 243px;
  }

  .svg {
    @keyframes waiting {
      0% { transform: rotate(0deg); }
      100% { transform: rotate(360deg); }
    }

    &.message-loading {
      animation: waiting 1.5s infinite linear;
    }
  }
}
</style>
